/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/KlarnaPayment/theme';

export const KlarnaPaymentTheme = theme;
